<script lang="ts" setup>
  withDefaults(
    defineProps<{
      direction?: 'down' | 'up';
    }>(),
    {
      direction: 'down',
    },
  );
</script>

<template>
  <svg
    class="[&.up_path]:ltr:rotate-180 [&.up_path]:rtl:-rotate-180"
    :class="direction"
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="origin-center duration-300"
      clip-rule="evenodd"
      d="M2.29144 6.282C2.68002 5.906 3.31003 5.906 3.69861 6.282L9.46534 11.8621C9.75779 12.1451 10.2422 12.1451 10.5347 11.8621L16.3014 6.282C16.69 5.906 17.32 5.906 17.7086 6.282C18.0971 6.65801 18.0971 7.26764 17.7086 7.64364L11.9418 13.2237C10.8722 14.2588 9.12778 14.2588 8.05816 13.2237L2.29144 7.64364C1.90285 7.26764 1.90285 6.65801 2.29144 6.282Z"
      fill="#095EA6"
      fill-rule="evenodd"
    />
  </svg>
</template>
